import styled from "styled-components";

export const ContainerUser = styled.div`
    display: flex;

    @media(max-width: 400px){
        flex-direction: column;
    }
`;

export const SpanComment = styled.span`
    font-size: 0.8rem;
    border-radius: 10px;
    padding: 5px;
    margin-bottom: 16px;
    background: var(--header-color);
    color: var(--input-font-color);
`;

export const ColumnFlex = styled.div`
    display: flex; 
    flex: 1;
    flex-direction: column;
`;
